import {
  HeaderSection,
  SingleRowWithCopy,
} from '@/features/ap_payees/components/PayeeDetailDrawer/components/Common';
import { ProxyReceivingMethodData } from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import parentStyles from '../../../../styles.module.scss';
import localStyles from './styles.module.scss';

const cx = classnames.bind({ ...parentStyles, ...localStyles });

type Props = {
  data?: ProxyReceivingMethodData;
};
export const ProxyReceivingMethod: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const { agentReceiveSetting } = data || {};
  const { address, destination, unique_code } = agentReceiveSetting || {};
  const value = `${address}${unique_code} ${destination}`;
  return (
    <div className={cx('subSectionContainer')}>
      <HeaderSection
        displayName={t('ap_payee_detail_drawer_proxy_receipt_receiving_method')}
        isSubHeader
      />
      <div className={cx('bodySectionContainer')}>
        <SingleRowWithCopy
          label={t('ap_payee_detail_drawer_proxy_receipt_address')}
          value={value}
        />
      </div>
    </div>
  );
};

ProxyReceivingMethod.displayName = 'ProxyReceivingMethod';
